import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PRICE, PRICE_PLN } from '../data/valueStack';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function ClosingWords() {
  return <section aria-labelledby="closing-heading" className="bg-night py-16 sm:py-24" data-id="element-46" data-mp="38vtx8rl2ncnc">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-47" data-mp="343alm05y2rl6">
        <Eyebrow align="center" data-id="element-48" data-mp="2z58tkpqjjhxk">Na koniec</Eyebrow>
        <h2 id="closing-heading" className="mt-5 font-display text-4xl leading-[0.95] sm:text-7xl" data-id="element-49" data-mp="2z5s9k0wmrw8y">
          <span className="block text-cream" data-id="element-50" data-mp="2u7qr9i7140yj">W tę niedzielę</span>
          <span className="block text-amber" data-id="element-51" data-mp="2q4u3ld2mtenq">niczego nie przygotowujesz.</span>
        </h2>
        <p className="mt-7 font-serif text-lg italic leading-relaxed text-cream-soft sm:text-xl" data-id="element-52" data-mp="2l4xzldtxpn86">
          Twój semestr gitary jazzowej jest już zaplanowany: 16 tygodni, 50 ćwiczeń, 3 ścieżki, 6
          tomów i 5 bonusów. Wszystko gotowe dziś za {PRICE} ({PRICE_PLN}), z 10-dniową gwarancją.
        </p>
        <div className="mt-9 flex flex-col items-center gap-4" data-id="element-53" data-mp="3byll790jy403">
          <CtaButton size="lg" data-id="element-54" data-mp="3bvzf7dtb7wjz">Chcę gotowy semestr teraz</CtaButton>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-55" data-mp="3fzxcdiz2qxae">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-cream-muted" data-id="element-56" data-mp="cioytbbdqjlh">
                <Icon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-57" data-mp="cgb4x5sfrdfi" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}